"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.logout = void 0;
const gqlClient_1 = require("../../utils/gqlClient");
const wrapQuery_1 = require("../../utils/wrapQuery");
const config_1 = require("../../utils/config");
const query = gqlClient_1.gql `
  query Logout($client: String!) {
    logout(clientId: $client)
  }
`;
function logout() {
    return __awaiter(this, void 0, void 0, function* () {
        return wrapQuery_1.wrapQuery('logout', query, { client: config_1.getClientId() });
    });
}
exports.logout = logout;
